export default "__VITE_ASSET__9c309c79__"